<template>
  <div class="tt-table">
    <el-table
      v-loading="loading"
      ref="table"
      :data="data"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      stripe
      style="width:100%;"
      v-on="$listeners"
      :header-row-class-name='$attrs.rowname'
    >
      <slot name="columns" />
    </el-table>
    <el-pagination
      v-bind="$attrs"
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :prev-text="prevText"
      :next-text="nextText"
      :page-sizes="pageSizes"
      :total="total"
      :layout="layout"
      style="padding:20px 0"
      class="tt-tac"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      v-on="$listeners"
    />
  </div>
</template>
<script>
export default {
  name: 'TTable',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    total: {
      type: Number,
      default: null
    },
    page: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 50]
      }
    },
    layout: {
      type: String,
      default: 'prev,pager,next,jumper,sizes,->,total'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    },
    prevText: {
      type: String,
      default: '上一页'
    },
    nextText: {
      type: String,
      default: '下一页'
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.page
      },
      set (val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get () {
        return this.limit
      },
      set (val) {
        this.$emit('update:limit', val)
      }
    },
    loading () {
      if (this.total === 0 && this.data.length === 0) {
        return false
      } else if (this.total >= 1 && this.data.length >= 1) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    getRef () {
      return this.$refs.table
    },
    handleSizeChange (val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange (val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  }
}
</script>

<style lang="less" scoped >
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TTable.vue